import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    q: "L'app fonctionne-t-elle hors connexion ?",
    a: 'Oui, vous pouvez enregistrer vos sessions hors ligne. Elles se synchroniseront automatiquement.',
  },
  {
    q: 'Quelles disciplines sont supportées ?',
    a: 'Skeet Olympique, Trap, DTL, Compak Sporting, Parcours de Chasse, Fosse Universelle, Double Trap et Ball-Trap Américain.',
  },
  {
    q: 'Puis-je annuler mon abonnement ?',
    a: 'Oui, à tout moment depuis les paramètres de votre Store (iOS) ou votre espace Stripe (Android).',
  },
  {
    q: 'Mes données sont-elles sécurisées ?',
    a: 'Oui, vos données sont stockées de manière sécurisée. Nous ne vendons ni ne partageons vos données. Conforme RGPD.',
  },
  {
    q: "Comment fonctionne l'essai gratuit ?",
    a: "7 jours d'accès complet, sans carte bancaire. Si ça vous plaît, vous choisissez votre formule.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 relative">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest font-['Poppins']"
          >
            FAQ
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-white font-['Poppins'] font-bold text-3xl sm:text-4xl mt-3"
          >
            Questions fréquentes
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-[#1A1A1A] rounded-xl border border-white/5 px-6 overflow-hidden hover:border-[#FF6B35]/20 transition-colors duration-300"
              >
                <AccordionTrigger className="text-white text-left font-['Poppins'] font-medium text-sm sm:text-base py-5 hover:no-underline hover:text-[#FF6B35] transition-colors [&>svg]:text-[#FF6B35]">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A0A0A0] text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
